import React from "react";

/**
 * Price — P Logo (SVG)
 * Reproduction fidèle du logo de l'app : carré rouge arrondi avec bordure
 * noire "street", P blanc au centre, petit rond orange en bas à droite.
 * Utilisé dans le header du site et le splash screen.
 */
export default function PLogo({ size = 64, className = "" }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      aria-label="Price"
    >
      {/* Ombre "street" décalée */}
      <rect x="12" y="12" width="76" height="76" rx="22" fill="#1E0910" />
      {/* Corps rouge */}
      <rect
        x="8"
        y="8"
        width="76"
        height="76"
        rx="22"
        fill="#F86A78"
        stroke="#1E0910"
        strokeWidth="5"
      />
      {/* P */}
      <text
        x="46"
        y="62"
        textAnchor="middle"
        fontFamily="Outfit, Arial, sans-serif"
        fontWeight="900"
        fontSize="52"
        fill="#FFF6EE"
      >
        P
      </text>
      {/* Point orange en bas à droite */}
      <circle cx="83" cy="72" r="8" fill="#F4A825" stroke="#1E0910" strokeWidth="3" />
    </svg>
  );
}
